module.exports = __webpack_public_path__ + "static/img/playLuckyWheel.d4233ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wheel/playLuckyWheel.png
// module id = fbAF
// module chunks = 0